import { render, staticRenderFns } from "./calendars.vue?vue&type=template&id=604a3d54"
import script from "./calendars.vue?vue&type=script&lang=js"
export * from "./calendars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports